<div class="custom-table-wrapper">
  <div class="no-data" *ngIf="!data">
    <app-loader></app-loader>
  </div>
  <div class="show-record">
    <div class="count record-warning" *ngIf="data && !data.length">{{noRecordTxt}}</div>
    <span class="count" *ngIf="data && data.length && !showrecord">{{data.length}} workflows</span>
    <span class="count" *ngIf="data && data.length && showrecord">{{data.length}} records</span>
    <span class="spacer"></span>
    <span class="workflow-button" *ngIf="showCountAllWorkflowButton && data && data.length">
      <app-button
        [name]="startAllWorkflowName"
        [type]="'outlined'"
        (btnClick)="onSelectStartAllWorkflows(data)"
        [disable]="isReportingCycleLocked || disableNotReadyWorkflows"
      >
      </app-button>
    </span>
    <span class="workflow-button" *ngIf="showApproveAllWorkflows && data && data.length">
      <app-button
        [name]="allWorkflowSelectionBtnTxt"
        [type]="'confirm'"
        (btnClick)="onApproveAllWorkflowsEvent(data)"
      >
      </app-button>
    </span>
  </div>
  <div class="table-wrapper" *ngIf="data && data.length">
    <table class="custom-table">
      <thead>
        <tr >
          <th *ngFor="let header of headers" [ngStyle]="{ width: header.width ? header.width : 'none', 'text-align': header.align ? header.align : 'none'}" (click)="sortData(header)">
            <p>{{ header.name }}</p>
            <span *ngIf="header.type === 'multiple-workflow-check'">
              <input
                class="check-box"
                type="checkbox"
                id="{{ header.key }}"
                [checked]="checkSelectAll"
                [ngClass]="(header.type === 'multiple-workflow-check' && !showCheckFieldForEndorser2) ? 'hidden' : ''"
                (change)="onSelectAllReportingWorkflows($event, data)"
                [disabled]="disableEndorser2CheckAll"
              />
            </span>
            <span *ngIf="header.type === 'nomination-multiple-workflow-check'">
              <input
                class="check-box"
                type="checkbox"
                id="{{ header.key }}"
                [checked]="checkSelectAll"
                [ngClass]="(header.type === 'nomination-multiple-workflow-check' && !showCheckFieldForEndorser1) ? 'hidden' : ''"
                (change)="onSelectAllNominationWorkflows($event, data)"
                [disabled]="disableEndorser1CheckAll"
              />
            </span>
            <span
              [ngClass]="header.sort == 'none' ? 'asc' : ''"
              [hidden]="
                header.name == '' ||
                header.name == null ||
                header.sort == 'asc' ||
                header.sort == 'none' ||
                header.hideSort
              "
            >
              <i class="fa fa-caret-up" aria-hidden="true"></i>
            </span>
            <span
              [hidden]="
                header.name == '' ||
                header.name == null ||
                header.sort == 'desc' ||
                header.sort == 'none' ||
                header.hideSort
              "
            >
              <i class="fa fa-caret-down" aria-hidden="true"></i>
            </span>
            <span
              [hidden]="
                header.name == '' ||
                header.name == null ||
                header.sort == 'desc' || header.sort == 'asc' ||
                header.hideSort
              "
            >
              <i class="fa fa-sort" aria-hidden="true"></i>
            </span>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr class="table-row" *ngFor="let item of data">
          <td *ngFor="let header of headers; let last = last"
            [ngSwitch]="header.type"
            [ngStyle]="{ width: header.width ? header.width : 'none', 'text-align': header.align ? header.align : 'none'}"
            [ngClass]="(item.workflowType == '2') && item.workflowStatus == '-1' && header.type != 'start-button' ? 'disablerow' : null"
            >
            <span *ngSwitchCase="'date'">
              {{ item[header.key] | datePipe }}
            </span>
            <span class="duedays" *ngSwitchCase="'DueDays'">
              <div [ngClass]="item[header.key] >= 0 ? 'positiveNumber': item[header.key] < 0 ? 'negetiveNumber': ''" *ngIf="item.workflowStatus !== '7'">
                {{item[header.key]}}
              </div>
            </span>
            <span [ngClass]="(item.workflowType == '2') && item.workflowStatus == '-1' ? 'disablerow' : null" *ngSwitchCase="'link-searchName'">
              <div [ngClass]="(item.workflowType == '2') && (item.workflowStatus == '-1' || (item.workflowStatus != '1' && disableConsentLink)) ? 'disable-link' : 'link'" innerHtml="{{ item[header.key] | highlightText : searchText }}" (click)="link(item)"></div>
            </span>
            <span *ngSwitchCase="'link-assignee'">
              <app-show-more-names [names]="item[header.key]" [searchText]="searchText"></app-show-more-names>
            </span>
            <span *ngSwitchCase="'searchName'">
              <div innerHtml="{{ item[header.key] | highlightText : searchText }}"></div>
            </span>
            <span class="table-btns" *ngSwitchCase="'edit-delete-button'">
              <div class="spacer"></div>
              <app-button
                [name]="'edit'"
                [type]="'small-outlined'"
                (btnClick)="edit(item)"
                [disable]="isReportingCycleLocked"
              ></app-button>
              <app-button
                [type]="'table-delete'"
                (btnClick)="delete(item)"
                [disable]="isReportingCycleLocked"
              ></app-button>
            </span>
            <span *ngSwitchCase="'checkField'">
              <input
                class="check-box"
                type="checkbox"
                id="{{ item[header.key] }}"
                (change)="onCheck($event, item, header.key)"
                [checked]="item[header.key] === '1'"
                [disabled]="isReportingCycleLocked || (checkboxDisable || item.workflowStatus == '1' || item.workflowStatus == '2' || item.workflowStatus == '3' || item.workflowStatus == '4' || item.workflowStatus == '5' || item.workflowStatus == '6' || item.workflowStatus == '7' || item.workflowStatus == '8' || item.workflowStatus == '9' || item.workflowStatus == '101')"
              />
            </span>

            <span class="table-btns" *ngSwitchCase="'delete-download-button'">
              <!--<div class="spacer"></div>-->
              <span class="download">
                  <app-button [type]="'small-outlined-download'" (btnClick)="download(item)"></app-button>
                </span>
              <app-button
               *ngIf="item && (item.workflowStatus == '8' || item.workflowStatus == '11') || (item.canEditReport && item.isAdmin)"
                [type]="'table-delete'"
                (btnClick)="delete(item)"
                [disable]="isReportingCycleLocked"
              ></app-button>
            </span>

            <span class="check-workflow" *ngSwitchCase="'multiple-workflow-check'">
              <span *ngIf="item && (item.workflowStatus == '3' || item.workflowStatus == '5')">
                <input
                class="check-box"
                type="checkbox"
                id="{{ item[header.key] }}"
                [checked]="item['checked']"
                (change)="onMultiWorkflowSelection($event, item)"
                [disabled]="(item.workflowType == '2' && item.workflowStatus == '5') || isReportingCycleLocked || !(item.wfLevel3UserID == loggedInUserID)"
              />
              </span>
              <span *ngIf="item && (item.workflowStatus == '4' || item.workflowStatus == '6')">
                <input
                class="check-box"
                type="checkbox"
                id="{{ item[header.key] }}"
                [checked]="item['checked']"
                (change)="onMultiWorkflowSelection($event, item)"
                [disabled]="isReportingCycleLocked || !(item.wfLevel4UserID == loggedInUserID)"
              />
              </span>
            </span>

            <span class="check-workflow" *ngSwitchCase="'nomination-multiple-workflow-check'">
              <span *ngIf="(item.workflowStatus == '3' || item.workflowStatus == '5') && (item.wfLevel3UserID == loggedInUserID)">
                <input
                class="check-box"
                type="checkbox"
                id="{{ item[header.key] }}"
                [checked]="item['checked']"
                [disabled]="isReportingCycleLocked"
                (change)="onMultiWorkflowSelection($event, item)"
              />
              </span>
            </span>

            <span class="table-btns" *ngSwitchCase="'download-button'">
              <div class="spacer"></div>
              <span class="download">
                <app-button [type]="'small-outlined-download'" (btnClick)="download(item)"></app-button>
              </span>
            </span>

            <span class="table-btns" *ngSwitchCase="'view-button'">
              <div class="spacer"></div>
              <app-button
              *ngIf="item.workflowStatus != '1' && item.workflowType != '2'"
              [name]="'view'"
              [type]="'small-outlined'"
              (btnClick)="link(item)"
              >
              </app-button>
              <div *ngIf="item.workflowType == '2'">
              <div ngbDropdown container="body">
              <button class="custom-btn "*ngIf="item.workflowStatus != '7'" ngbDropdownToggle>Actions</button>
              <button class="custom-btn " *ngIf="item.workflowStatus == '7'"ngbDropdownToggle>View</button>
              <div ngbDropdownMenu>
              <button ngbDropdownItem (click)="cpQpReport(item)">CP Report/TRS upload</button>
              <button ngbDropdownItem [disabled]="item.workflowStatus !== '7'" (click)="onConsent(item)">View Printer Proofs and Consent</button>
              </div>
              </div>
              </div>
              </span>
            <span class="table-btns" *ngSwitchCase="'cp-view-button'">
              <div class="spacer"></div>
              <app-button
                *ngIf="item.workflowStatus == '1'"
                [name]="'view'"
                [type]="'small-outlined'"
                (btnClick)="onSelect(item)"
              >
              </app-button>
              <div *ngIf="(item.workflowStatus == '8') && (item.workflowType == '2')">
                <div ngbDropdown container="body">
                  <button class="custom-btn " ngbDropdownToggle>Actions</button>
                  <div ngbDropdownMenu>
                    <button [disabled]="isReportingCycleLocked" ngbDropdownItem (click)="cpQpReport(item)">CP Report/TRS upload</button>
                    <button [disabled]="isReportingCycleLocked" ngbDropdownItem (click)="onConsent(item)">View Printer Proofs and Consent</button>
                  </div>
                  </div>
              </div>
            </span>

            <span class="table-btns" *ngSwitchCase="'lock-detail-button'">
              <div class="spacer"></div>
              <span class="download"
                [ngbTooltip]="item['isLocked'] === '0' || (item['isLocked'] === '1' && item['isLockedByID'] == loggedInUserID) ? 'Open' : 'Locked'">
                <app-button [disable]="isReportingCycleLocked"
                *ngIf="(item.workflowType != '2') && (item.wfLevel1UserID && item.wfLevel1UserID.includes(loggedInUserID))"
                [name]="''"
                [type]="(item['isLocked'] === '0') || (item['isLocked'] === '1' && item['isLockedByID'] == loggedInUserID) ? 'unlock-workflow': 'lock-workflow'"
                (btnClick)="lockUnlock(item)"
                >
                </app-button>
              </span>
            </span>

            <span class="table-btns" *ngSwitchCase="'import-export-button'">
              <div class="spacer"></div>
              <span class="download-upload" *ngIf="(item.workflowType != '2') && (item.wfLevel1UserID && item.wfLevel1UserID.includes(loggedInUserID))">
                <app-button [type]="'small-outlined-download'" (btnClick)="export(item)"></app-button>
                <app-button [type]="'small-outlined-upload'"  [disable]= "(item['isLocked'] === '1' && !(item['isLockedByID'] == loggedInUserID)) || isReportingCycleLocked" (btnClick)="import(item)"></app-button>
              </span>
            </span>

            <span class="table-btns" *ngSwitchCase="'nomination-btn'">
              <!-- [disable]="item && !(item.workflowStatus == '4' || item.workflowStatus == '6') && !(item.wfLevel2UserID == loggedInUserID)" -->
              <!-- *ngIf="item && (item.workflowStatus == '1' || item.workflowStatus == '2' || item.workflowStatus == '7')" -->
              <app-button
                [type]="'outlined'"
                [name]="'View Nomination'"
                (btnClick)="viewNomination(item)"
              ></app-button>
            </span>
            <span class="table-btns" *ngSwitchCase="'nomination-approve-reject-btn'">
              <div *ngIf="item.workflowStatus == '101'">
                <app-button [name]="'refresh'" [type]="'outlined'" (btnClick)='refreshData.emit()'></app-button>
              </div>
              <!-- [disable]="item && !(item.workflowStatus == '4' || item.workflowStatus == '6') && !(item.wfLevel4UserID == loggedInUserID)" -->
              <app-button
              *ngIf="item && (item.workflowStatus === '4' || item.workflowStatus == '6' || item.workflowStatus == '2')"
              [type]="'outlined'"
                [name]="'View Nomination'"
                (btnClick)="viewNomination(item)"
              ></app-button>
              <app-button
              *ngIf="item && (item.workflowStatus == '3' || item.workflowStatus == '5')"
                [disable]="isReportingCycleLocked || (item && !(item.workflowStatus == '3' || item.workflowStatus == '5') && !(item.wfLevel3UserID == loggedInUserID)) || showApproveAllWorkflows"
                [name]="'Reject'"
                [type]="'cancel'"
                (btnClick)="onEndorser3RejectEvent(item)"
              ></app-button>
              <app-button
              *ngIf="item && (item.workflowStatus == '3' || item.workflowStatus == '5')"
                [disable]="isReportingCycleLocked || (item && !(item.workflowStatus == '3' || item.workflowStatus == '5') && !(item.wfLevel3UserID == loggedInUserID)) || showApproveAllWorkflows"
                [name]="'Approve'"
                [type]="'success'"
                (btnClick)="onEndorser3EndorserEvent(item)"
              ></app-button>
            </span>
            <span class="table-btns" *ngSwitchCase="'acknowledge-report-buttons'">
              <div *ngIf="((item.workflowStatus == '3' || item.workflowStatus == '5') && (item.workflowType == '2'))">
                <div ngbDropdown container="body">
                  <button class="custom-btn " ngbDropdownToggle>Actions</button>
                  <div ngbDropdownMenu>
                    <button ngbDropdownItem (click)="acknowledge(item)">Acknowledge</button>
                    <button ngbDropdownItem (click)="cpQpReport(item)">CP Report/ TRS upload</button>
                  </div>
                  </div>
              </div>
            </span>
            <span class="table-btns" *ngSwitchCase="'start-button'">
              <div *ngIf="item.workflowStatus == '101'">
                <app-button [name]="'refresh'" [type]="'outlined'" (btnClick)='refreshData.emit()'></app-button>
              </div>
              <div  *ngIf="(item.workflowStatus == '11') && showActions">
                <div ngbDropdown container="body">
                  <button class="custom-btn " ngbDropdownToggle>Actions</button>
                  <div ngbDropdownMenu *ngIf="!isCPQPUser">
                    <button [disabled]="isReportingCycleLocked" ngbDropdownItem (click)="reset(item)">Reset</button>
                    <button ngbDropdownItem (click)="viewLogHistory(item)">View Log History</button>
                  </div>
                </div>
              </div>
              <div  *ngIf="(item.workflowStatus == '1' || item.workflowStatus == '2'  || item.workflowStatus == '3'  || item.workflowStatus == '4' || item.workflowStatus == '5' ||item.workflowStatus == '6' || item.workflowStatus == '7' || item.workflowStatus == '8') && showActions">
                <div ngbDropdown container="body">
                  <button class="custom-btn " ngbDropdownToggle>Actions</button>
                  <div ngbDropdownMenu *ngIf="!isCPQPUser && (item.workflowType != '2')">
                    <button [disabled]="isReportingCycleLocked" ngbDropdownItem (click)="reset(item)">Reset</button>
                    <button [disabled]="isReportingCycleLocked || item.wfLevel1Status!= '2'" ngbDropdownItem (click)="restart(item)">Restart</button>
                    <button [disabled]="isReportingCycleLocked || item.workflowStatus == '7'" ngbDropdownItem (click)="update(item)"> Update</button>
                    <button [disabled]="isReportingCycleLocked || (item.isLocked == '0' || item.workflowStatus != '1')" ngbDropdownItem (click)="unlock(item)">Unlock</button>
                    <button ngbDropdownItem (click)="viewLogHistory(item)">View Log History</button>

                  </div>
                  <div ngbDropdownMenu *ngIf="isCPQPUser">
                    <button ngbDropdownItem (click)="link(item)" [disabled]="isReportingCycleLocked || item.workflowStatus !== '1'">Update Profile</button>
                    <button ngbDropdownItem (click)="viewNomination(item)">View Nomination</button>
                  </div>
                  <div  ngbDropdownMenu *ngIf="(item.workflowType == '2')">
                    <button [disabled]="isReportingCycleLocked" ngbDropdownItem (click)="reset(item)">Reset</button>
                    <button [disabled]="isReportingCycleLocked || (item.wfLevel1Status!= '2')" ngbDropdownItem (click)="restart(item)">Restart</button>
                    <button  ngbDropdownItem (click)="cpQpReport(item)">CP Report/ TRS upload</button>
                    <button  ngbDropdownItem (click)="printerProof(item)">Printer Proof</button>
                    <button ngbDropdownItem (click)="viewLogHistory(item)">View Log History</button>
                    <button [disabled]="isReportingCycleLocked" *ngIf="item.workflowStatus == '1'" ngbDropdownItem (click)="consentOnBehalf(item)">Consent on Behalf</button>
                  </div>
                </div>
              </div>
              <div *ngIf="(item.workflowStatus == '1' || item.workflowStatus == '2'  || item.workflowStatus == '3'  || item.workflowStatus == '4' || item.workflowStatus == '5' || item.workflowStatus == '6' || item.workflowStatus == '7' || item.workflowStatus == '8') && enableCPQPNomination">
                <div ngbDropdown container="body">
                  <button [ngClass]="isReportingCycleLocked ? 'disableActionButton' : 'custom-btn'" ngbDropdownToggle >Actions</button>
                  <div ngbDropdownMenu>
                    <button [disabled]="isReportingCycleLocked" ngbDropdownItem (click)="reset(item)">Reset</button>
                    <button [disabled]="isReportingCycleLocked || (item.workflowStatus == '1' || item.workflowStatus == '7')" ngbDropdownItem (click)="update(item)"> Update</button>
                    <button ngbDropdownItem (click)="viewNomination(item)">View Nomination</button>

                  </div>
                </div>
              </div>
              <div *ngIf="(item.workflowStatus === '0' || item.workflowStatus === '-1') && adminLanding">
                  <app-button
                      [name]="'Start Workflow'"
                      [type]="'outlined'"
                      (btnClick)="onSelectStartWorkflow(item)"
                      [tooltiptext]="isReportingCycleLocked ? reportingCycleLockedMessage : !enableCPQPNomination && item.workflowBooleanStatus && item.reportingName == uploadConsentASX ? notReadyAsxConsentTooltip
                          : !enableCPQPNomination && item.workflowBooleanStatus && item.reportingName === uploadConsentUSSEC ? notReadyUssecConsentTooltip
                          : !enableCPQPNomination && item.workflowBooleanStatus && (item.workflowType != '2') ? notReadyWorkflowTooltip
                          : !enableCPQPNomination ? ReadyWorkflowTooltip : null"
                      [disable]='item.workflowBooleanStatus !== undefined && item.workflowBooleanStatus !== "" ? isReportingCycleLocked || item.workflowBooleanStatus : isReportingCycleLocked'
                    >
                    </app-button>
              </div>
              <div *ngIf="item.workflowStatus === '102' && adminLanding">
                  <app-button
                  [name]="'Start Workflow'"
                  [type]="'outlined'"
                  [tooltiptext]="preRequisiteTooltip"
                  [disable]='true'
                >
                </app-button>
              </div>
            </span>
            <span class="table-btns" *ngSwitchCase="'enter-view-data-button'">
              <app-button
                *ngIf="(item['isLocked'] === '1' && item['isLockedByID'] != loggedInUserID) && (item.workflowType != '2')"
                [name]="'view'"
                [type]="'outlined'"
                (btnClick)="link(item)"
              >
              </app-button>
              <app-button
                *ngIf="(item['isLocked'] === '0' || (item['isLocked'] === '1' && item['isLockedByID'] == loggedInUserID)) && (item.workflowType != '2') && (item.wfLevel1UserID && item.wfLevel1UserID.includes(loggedInUserID))"
                [name]="'Enter data'"
                [type]="'outlined'"
                (btnClick)="link(item)"
                [disable]="isReportingCycleLocked"
              >
              </app-button>
              <div *ngIf="item.workflowType == '2'">
                <div ngbDropdown container="body">
                  <button class="custom-btn " ngbDropdownToggle>Actions</button>
                  <div ngbDropdownMenu>
                    <button ngbDropdownItem (click)="cpQpReport(item)">CP Report/TRS upload</button>
                    <button ngbDropdownItem [disabled]="item.workflowStatus !== '1'" (click)="onConsent(item)">View Printer Proofs and Consent</button>
                  </div>
                  </div>
              </div>
            </span>
            <span class="table-btns" *ngSwitchCase="'view-nomination-form'">
              <div ngbDropdown container="body">
              <button class="custom-btn " ngbDropdownToggle>Actions</button>
                <div ngbDropdownMenu *ngIf="item.workflowStatus === '1'">
                  <button ngbDropdownItem (click)="link(item)" [disabled]="disableUpdateProfile">Update Profile</button>
                  <button ngbDropdownItem (click)="viewNomination(item)">View Nomination</button>
                </div>
              </div>
            </span>
            <span class="table-btns" *ngSwitchCase="'lock-import-reject-approve-button'">
              <div *ngIf="item.workflowStatus == '101'">
                <app-button [name]="'refresh'" [type]="'outlined'" (btnClick)='refreshData.emit()'></app-button>
              </div>
              <span class="table-btns button-width" *ngIf="item.workflowStatus == '2' && item.workflowType != '2' && !(item.wfLevel2UserID == loggedInUserID)">
                <app-button
                  [name]="'view'"
                  [type]="'outlined'"
                  (btnClick)="link(item)"
                >
                </app-button>
              </span>
              <app-button
                *ngIf="item.workflowStatus == '2' && item.workflowType != '2' && (item.wfLevel2UserID == loggedInUserID)"
                [disable]="isReportingCycleLocked"
                [name]="'Reject'"
                [type]="'cancel'"
                (btnClick)="onORCRejectEvent(item)"
              >
              </app-button>
              <app-button
                *ngIf="item.workflowStatus == '2' && item.workflowType != '2' && (item.wfLevel2UserID == loggedInUserID)"
                [disable]="isReportingCycleLocked"
                [name]="'Approve'"
                [type]="'success'"
                (btnClick)="onORCApproveEvent(item)"
              >
              </app-button>
              <!-- <span class="table-btns button-lock-unlock-width" *ngIf="item.workflowStatus != '2' && item.reportingName !== uploadConsentASX && item.reportingName !== uploadConsentUSSEC">
                <app-button
                  [name]="''"
                  [type]="(item['isLocked'] === '0') ? 'unlock-workflow': 'lock-workflow'"
                  (btnClick)="lockUnlock(item)"
                  [ngbTooltip]="item['isLocked'] === '0' ? 'Open' : 'Locked'"
                >
                </app-button>
              </span>
              <span class="table-btns button-width" *ngIf="item.workflowStatus != '2' && item.reportingName !== uploadConsentASX && item.reportingName !== uploadConsentUSSEC">
                <app-button [type]="'small-outlined-download'" (btnClick)="export(item)"></app-button>
                <app-button [type]="'small-outlined-upload'" [disable]= "item['isLocked'] === '1' && !(item['isLockedByID'] == loggedInUserID)" (btnClick)="import(item)"></app-button>
              </span> -->
              <span class="table-btns button-width" *ngIf="item.workflowStatus != '2'">
                <app-button
                  [name]="'view'"
                  [type]="'outlined'"
                  (btnClick)="link(item)"
                >
                </app-button>
              </span>
            </span>
            <span *ngSwitchCase="'status-button'">
                  <span class="disc" [ngbTooltip]="item.wfLevel1UserName"  [ngClass]="item.wfLevel1Status==1? 'warning':item.wfLevel1Status==2? 'success' : item.wfLevel1Status==3 ? 'danger':item.wfLevel1Status==4 ? 'processingfailed':'null'">
                  </span>
                  <span class="disc"[ngbTooltip]="item.wfLevel2UserName" [ngClass]="item.wfLevel2Status==1? 'warning':item.wfLevel2Status==2? 'success' : item.wfLevel2Status==3 ? 'danger':item.wfLevel2Status==4 ? 'processingfailed':'null'">
                  </span>
                  <span class="disc" *ngIf="!(isCpQpNomination && (item.isNewCPQP === '0'))" [ngbTooltip]="item.wfLevel3UserName" [ngClass]="item.wfLevel3Status==1? 'warning':item.wfLevel3Status==2? 'success' : item.wfLevel3Status==3 ? 'danger': item.wfLevel3Status==4 ? 'processingfailed':'null'">
                  </span>
                  <span class="disc" [ngbTooltip]="item.wfLevel4UserName" [ngClass]="item.wfLevel4Status==1? 'warning':item.wfLevel4Status==2? 'success' : item.wfLevel4Status==3 ? 'danger':item.wfLevel4Status==4 ? 'processingfailed':'null'">
                  </span>
            </span>

            <span class="reject-approve-btns" *ngSwitchCase="'reject-approve-view-button'">
              <div *ngIf="item.workflowStatus == '101'">
                <app-button [name]="'refresh'" [type]="'outlined'" (btnClick)='refreshData.emit()'></app-button>
              </div>
              <app-button
                *ngIf="item.workflowStatus == '2' && item.workflowType != '2'"
                [disable]="isReportingCycleLocked || !(item.wfLevel2UserID == loggedInUserID)"
                [name]="'Reject'"
                [type]="'cancel'"
                (btnClick)="onORCRejectEvent(item)"
              >
              </app-button>
              <app-button
                *ngIf="item.workflowStatus == '2' && item.workflowType != '2'"
                [disable]="isReportingCycleLocked || !(item.wfLevel2UserID == loggedInUserID)"
                [name]="'Approve'"
                [type]="'success'"
                (btnClick)="onORCApproveEvent(item)"
              >
              </app-button>
              <div *ngIf="item.workflowStatus != '2' && item.workflowStatus != '101'" class="display-btns btn-width">
                <div class="spacer"></div>
                <app-button
                  [name]="'view'"
                  [type]="'small-outlined'"
                  (btnClick)="link(item)"
               >
                </app-button>
              </div>
            </span>
            <span class="reject-approve-btns" *ngSwitchCase="'reject-endorse-button'">
              <div *ngIf="item.workflowStatus == '101'">
                <app-button [name]="'refresh'" [type]="'outlined'" (btnClick)='refreshData.emit()'></app-button>
              </div>
              <div *ngIf="item.workflowType != '2'" class="btn-width">
                <div *ngIf="item.workflowStatus == '3' || item.workflowStatus == '5'">
                  <div *ngIf="(item.wfLevel3UserID == loggedInUserID)" class='display-btns'>
                    <app-button [name]="'Reject'" [type]="'cancel'" [disable]="isReportingCycleLocked || showApproveAllWorkflows" (btnClick)="onEndorser3RejectEvent(item)">
                    </app-button>
                    <app-button [name]="'Endorse'" [type]="'success'" [disable]="isReportingCycleLocked || showApproveAllWorkflows" (btnClick)="onEndorser3EndorserEvent(item)">
                    </app-button>
                  </div>
                  <div *ngIf="!(item.wfLevel3UserID == loggedInUserID)" class='display-btns'>
                    <div class="spacer"></div>
                    <app-button [name]="'view'" [type]="'small-outlined'" (btnClick)="link(item)">
                    </app-button>
                  </div>
                </div>
                <div *ngIf="(item.workflowStatus == '4' || item.workflowStatus == '6')">
                  <div *ngIf="(item.wfLevel4UserID == loggedInUserID)" class='display-btns'>
                    <app-button [name]="'Reject'" [type]="'cancel'" [disable]="isReportingCycleLocked || showApproveAllWorkflows" (btnClick)="onEndorser4RejectEvent(item)">
                    </app-button>
                    <app-button [name]="'Endorse'" [type]="'success'" [disable]="isReportingCycleLocked || showApproveAllWorkflows" (btnClick)="onEndorser4EndorserEvent(item)">
                    </app-button>
                  </div>
                  <div *ngIf="!(item.wfLevel4UserID == loggedInUserID)" class='display-btns'>
                    <div class="spacer"></div>
                    <app-button [name]="'view'" [type]="'small-outlined'" (btnClick)="link(item)">
                    </app-button>
                  </div>
                </div>
              </div>

              <div *ngIf="((item.workflowStatus == '3' || item.workflowStatus == '5') && item.workflowType == '2')">
                <div ngbDropdown container="body">
                  <div class="spacer"></div>
                  <button class="custom-btn " ngbDropdownToggle>Actions</button>
                  <div ngbDropdownMenu>
                    <button ngbDropdownItem (click)="acknowledge(item)">Acknowledge</button>
                    <button ngbDropdownItem (click)="cpQpReport(item)">CP Report/ TRS upload</button>
                  </div>
                </div>
              </div>

              <div class="display-btns btn-width" *ngIf="(item.workflowStatus != '3' && item.workflowStatus != '4' && item.workflowStatus != '5' && item.workflowStatus != '6' && item.workflowStatus != '101')">
                <div class="spacer"></div>
                  <app-button [name]="'view'" [type]="'small-outlined'" (btnClick)="link(item)">
                  </app-button>
              </div>
            </span>

            <span class="table-btns" *ngSwitchCase="'lock-export-view-only-button'">
              <span class="table-btns button-lock-unlock-width" *ngIf="item.workflowType != '2'">
                <app-button
                  [name]="''"
                  [type]="(item['isLocked'] === '0') ? 'unlock-workflow': 'lock-workflow'"
                  (btnClick)="lockUnlock(item)"
                  [ngbTooltip]="item['isLocked'] === '0' ? 'Open' : 'Locked'"
                >
                </app-button>
              </span>
              <span class="table-btns button-width" *ngIf="item.workflowType != '2'">
                <div class="spacer"></div>
                <app-button [type]="'small-outlined-download'" (btnClick)="export(item)"></app-button>
                <app-button *ngIf="!isUserRoleConsumer" [type]="'small-outlined-upload'" [disable]= "true" (btnClick)="import(item)"></app-button>
              </span>
              <span class="table-btns button-width" *ngIf="item.workflowType != '2'">
                <div class="spacer"></div>
                <app-button
                  [name]="'view'"
                  [type]="'outlined'"
                  (btnClick)="link(item)"
                >
                </app-button>
              </span>
              <div *ngIf="item.workflowType == '2'">
                <div ngbDropdown container="body">
                  <div class="spacer"></div>
                  <button *ngIf="!isUserRoleConsumer" [ngClass]="item.workflowStatus == '-1' ? 'disableActionButton' : 'custom-btn'" ngbDropdownToggle>Actions</button>
                  <button *ngIf="isUserRoleConsumer" [ngClass]="item.workflowStatus == '-1' ? 'disableActionButton' : 'custom-btn'" ngbDropdownToggle>View</button>
                  <div ngbDropdownMenu>
                    <button *ngIf="!isUserRoleConsumer" ngbDropdownItem (click)="cpQpReport(item)">CP Report/TRS upload</button>
                    <button *ngIf="isUserRoleConsumer" ngbDropdownItem (click)="cpQpReport(item)">CP Report/TRS</button>
                    <button ngbDropdownItem (click)="onConsent(item)">View Printer Proofs and Consent</button>
                  </div>
                </div>
              </div>
            </span>

            <span class="table-btns" *ngSwitchCase="'view-lock-export-view-only-button'">
              <!-- <span class="table-btns button-lock-unlock-width" *ngIf="item.workflowType != '2'">
                <app-button
                  [name]="''"
                  [type]="(item['isLocked'] === '0') ? 'unlock-workflow': 'lock-workflow'"
                  (btnClick)="lockUnlock(item)"
                  [ngbTooltip]="item['isLocked'] === '0' ? 'Open' : 'Locked'"
                >
                </app-button>
              </span> -->
              <span class="table-btns button-width" *ngIf="item.workflowType != '2'">
                <div class="spacer"></div>
                <app-button [type]="'small-outlined-download'" (btnClick)="export(item)"></app-button>
                <app-button *ngIf="!isUserRoleConsumer" [type]="'small-outlined-upload'" [disable]= "true" (btnClick)="import(item)"></app-button>
              </span>
              <span class="table-btns button-width" *ngIf="item.workflowType != '2'">
                <div class="spacer"></div>
                <app-button
                  [name]="'view'"
                  [type]="'outlined'"
                  (btnClick)="link(item)"
                >
                </app-button>
              </span>
              <div *ngIf="item.workflowType == '2'">
                <div ngbDropdown container="body">
                  <div class="spacer"></div>
                  <button [ngClass]="item.workflowStatus == '-1' ? 'disableActionButton' : 'custom-btn'" ngbDropdownToggle>View</button>
                  <div ngbDropdownMenu>
                    <button *ngIf="!isUserRoleConsumer" ngbDropdownItem (click)="cpQpReport(item)">CP Report/TRS upload</button>
                    <button *ngIf="isUserRoleConsumer" ngbDropdownItem (click)="cpQpReport(item)">CP Report/TRS</button>
                    <button ngbDropdownItem (click)="onConsent(item)">View Printer Proofs and Consent </button>
                  </div>
                </div>
              </div>
            </span>

            <span *ngSwitchDefault>
              {{ item[header.key] }}
            </span>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
